import http from "./index";

const getAll = () => {
  return http.get("/users");
};

const getOne = (id) => {
  return http.get(`/users/${id}`);
};

const create = (data) => {
  return http.post("/users", data);
};

const update = (id, data) => {
  return http.put(`/users/${id}`, data);
};

const remove = (id) => {
  return http.delete(`/users/${id}`);
};

const userService = {
  getAll,
  getOne,
  create,
  update,
  remove,
};

export default userService;
